<h2 mat-dialog-title class="error-title">Success</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
  @if (data.link) {
    <a mat-button [href]="data.link" target="_blank" class="success-link" style="color: blue; text-decoration: underline">{{data.linkText}}</a>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="button" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>